import * as THREE from 'three'

export type VisualPartRole='body'|'garment'|'armor'|'weapon'|'hair'|'accessory'|'fx'|'unknown'

const ROLE_RULES:Array<[VisualPartRole,RegExp]>=[
  ['hair',/hair|brow|beard|lash/i],
  ['weapon',/weapon|sword|blade|axe|gun|rifle|staff|spear|shield|dagger|katana|bow/i],
  ['armor',/armor|armour|plate|pauldron|gauntlet|greave|helmet|helm/i],
  ['garment',/cloth|shirt|coat|cape|cloak|mantle|pants|trouser|skirt|robe|jacket|hood|dress|channel/i],
  ['accessory',/access|belt|strap|chain|bag|pack|holster|pendant|ring|amulet|gauge|earring|pierc/i],
  ['body',/body|skin|head|face|torso|chest|arm|leg|hand|foot/i],
  ['fx',/fx|vfx|glow|aura|trail|energy/i],
]
export function classifyVisualPart(name:string):VisualPartRole{
  for(const[role,rule]of ROLE_RULES)if(rule.test(name))return role
  return'unknown'
}
function materialList(material:THREE.Material|THREE.Material[]){return Array.isArray(material)?material:[material]}
export function prepareFighterVisualIntegrity(root:THREE.Object3D){
  let index=0
  root.traverse(node=>{
    if(!(node instanceof THREE.Mesh))return
    const role=classifyVisualPart(node.name||node.parent?.name||'')
    node.userData.visualPartRole=role
    node.userData.visualIntegrityIndex=index++
    node.castShadow=true
    node.receiveShadow=true
    if(node instanceof THREE.SkinnedMesh){
      node.frustumCulled=false
      node.normalizeSkinWeights()
      node.skeleton.update()
    }
    if(node.geometry){
      if(!node.geometry.boundingBox)node.geometry.computeBoundingBox()
      if(!node.geometry.boundingSphere)node.geometry.computeBoundingSphere()
    }
    const mats=materialList(node.material).map(source=>{
      const m=source.clone()
      if(m instanceof THREE.MeshStandardMaterial){
        // Preserve authored PBR identity. Repair only invalid/out-of-range values.
        if(!Number.isFinite(m.envMapIntensity)||m.envMapIntensity<0)m.envMapIntensity=1
        if(!Number.isFinite(m.roughness))m.roughness=.5
        else m.roughness=THREE.MathUtils.clamp(m.roughness,0,1)
        if(!Number.isFinite(m.metalness))m.metalness=0
        else m.metalness=THREE.MathUtils.clamp(m.metalness,0,1)
        if(role==='garment'||role==='armor'||role==='accessory'){m.polygonOffset=true;m.polygonOffsetFactor=-.45;m.polygonOffsetUnits=-.45}
        if(m.transparent)m.depthWrite=false
      }
      m.needsUpdate=true
      return m
    })
    node.material=Array.isArray(node.material)?mats:mats[0]
    node.renderOrder=role==='body'?10:role==='garment'?20:role==='armor'?24:role==='hair'?28:role==='weapon'?32:role==='accessory'?36:role==='fx'?50:16
  })
  root.updateMatrixWorld(true)
  return root
}
